/* ============================================================
   Nettoyage des fichiers personnalisés au retrait du panier
   ------------------------------------------------------------
   Quand un article personnalisé quitte le panier (quantité -> 0,
   bouton supprimer, vidage), on supprime côté backend le design
   (aperçu) et le logo associés, via :
     DELETE {APP_URL}/api/customizer/designs/{designId}
     DELETE {APP_URL}/api/customizer/uploads/{logoUploadId}

   Détection robuste par DIFF du panier : on garde un instantané des
   lignes (key -> properties) et, après chaque mutation panier, on
   compare ; toute ligne disparue est nettoyée avec ses anciennes
   properties.

   Règles (cf. agent.contexte-suppression-panier.md) :
   - best-effort : ne bloque JAMAIS le panier (catch silencieux).
   - idempotent : un 404 = déjà supprimé => OK.
   - ne se déclenche que sur les mutations panier storefront
     (add/change/update/clear) — pas au passage de commande.
   ============================================================ */
(function () {
  var tag = document.getElementById('pe-cart-cleanup');
  var BACKEND = ((tag && tag.getAttribute('data-backend-url')) || window.__PE_BACKEND_URL__ || '').replace(
    /\/+$/,
    ''
  );
  if (!BACKEND) return;

  var snapshot = {}; // key -> properties
  var busy = false;

  function indexCart(cart) {
    var map = {};
    (cart && cart.items ? cart.items : []).forEach(function (it) {
      map[it.key] = it.properties || {};
    });
    return map;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function refreshSnapshot() {
    return getCart()
      .then(function (cart) {
        snapshot = indexCart(cart);
      })
      .catch(function () {});
  }

  // Récupère tous les ids design/logo d'une ligne (multi-angles supportés)
  function collectIds(props) {
    var designIds = [];
    var logoIds = [];
    if (!props) return { designIds: designIds, logoIds: logoIds };
    Object.keys(props).forEach(function (k) {
      var v = props[k];
      if (!v) return;
      if (k === '_design_id' || k.indexOf('_design_id_') === 0) designIds.push(v);
      if (k === '_logo_upload_id' || k.indexOf('_logo_upload_id_') === 0) logoIds.push(v);
    });
    return { designIds: designIds, logoIds: logoIds };
  }

  function del(path) {
    return fetch(BACKEND + path, { method: 'DELETE', keepalive: true }).catch(function () {});
  }

  // Supprime design PUIS logo (ordre conseillé par le backend)
  function cleanup(props) {
    var ids = collectIds(props);
    var chain = Promise.resolve();
    ids.designIds.forEach(function (id) {
      chain = chain.then(function () {
        return del('/api/customizer/designs/' + encodeURIComponent(id));
      });
    });
    ids.logoIds.forEach(function (id) {
      chain = chain.then(function () {
        return del('/api/customizer/uploads/' + encodeURIComponent(id));
      });
    });
    return chain;
  }

  // Compare l'état courant à l'instantané : nettoie chaque ligne disparue
  function diffAndCleanup() {
    if (busy) return;
    busy = true;
    var prev = snapshot;
    return getCart()
      .then(function (cart) {
        var now = indexCart(cart);
        Object.keys(prev).forEach(function (key) {
          if (!now[key]) cleanup(prev[key]);
        });
        snapshot = now;
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  }

  var MUT = /\/cart\/(add|change|update|clear)/i;

  // --- Patch fetch ---
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isMut = MUT.test(url);
      var p = origFetch.apply(this, arguments);
      if (isMut) {
        p.then(function () {
          diffAndCleanup();
        }).catch(function () {});
      }
      return p;
    };
  }

  // --- Patch XMLHttpRequest (certains thèmes / apps l'utilisent) ---
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__peMut = MUT.test(url || '');
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__peMut) {
      this.addEventListener('loadend', function () {
        diffAndCleanup();
      });
    }
    return origSend.apply(this, arguments);
  };

  // Instantané initial
  if (document.readyState !== 'loading') refreshSnapshot();
  else document.addEventListener('DOMContentLoaded', refreshSnapshot);
})();
